export {MidiRecorderInput}

class MidiRecorderInput implements WebMidi.MIDIInput{
    connection: WebMidi.MIDIPortConnectionState = "open";
    id: string = "MidiRecorderInput";
    state: WebMidi.MIDIPortDeviceState = "connected";
    type: WebMidi.MIDIPortType = "input";

    addEventListener(type: string, listener: EventListener | EventListenerObject | null, options?: boolean | AddEventListenerOptions): void;
    addEventListener(type: string, listener: EventListener | EventListenerObject | null, options?: boolean | AddEventListenerOptions): void;
    addEventListener(type: string, listener: EventListener | EventListenerObject | null, options?: boolean | AddEventListenerOptions): void {
    }

    close(): Promise<WebMidi.MIDIPort> {
        return new Promise<WebMidi.MIDIInput>((resolve, reject) => {});
    }

    dispatchEvent(event: Event): boolean;
    dispatchEvent(event: Event): boolean;
    dispatchEvent(event: Event): boolean {
        return false;
    }

    onmidimessage(e: WebMidi.MIDIMessageEvent): void {
    }

    onstatechange(e: WebMidi.MIDIConnectionEvent): void {
    }

    open(): Promise<WebMidi.MIDIPort> {
        return new Promise<WebMidi.MIDIInput>((resolve, reject) => {});
    }

    removeEventListener(type: string, callback: EventListener | EventListenerObject | null, options?: EventListenerOptions | boolean): void;
    removeEventListener(type: string, callback: EventListener | EventListenerObject | null, options?: EventListenerOptions | boolean): void;
    removeEventListener(type: string, callback: EventListener | EventListenerObject | null, options?: EventListenerOptions | boolean): void {
    }

}